﻿$.fn.dxCtrlFichier2VisuPdf = function custom_dxCtrlFichier2VisuPdf(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2visupdf");
        this.instance = new cdxCtrlFichier2VisuPdf(this, option);
    }
    return this;
}

window.cdxCtrlFichier2VisuPdf = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dx = null
    function mConstruit() {
        container.empty();
        container.css("height", "100%")
        $EleDoc = $("<iframe style='height:100%;width:100%;border-radius:3px;box-sizing:border-box;border:none;'/>")
        var url = option.itemData.url
        if (url.startsWith("//")) url = url.substring(1)
        if (url.startsWith("~")) url = url.substring(1)
        $EleDoc.attr('src', url);
        $EleDoc.appendTo(container);
    }

    this.element = function () { return container }

    mConstruit();
}